import juniAxios from 'services/axios';

export async function list(params) {
  return (await juniAxios.get(`/instructor/additional_classes/`, { params })).data
    .data;
}
